'use strict';

module.exports = /[&<>]/g;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/HTML_ESCAPE_REG.js
// module id = 944
// module chunks = 0